<template>
  <v-dialog v-model="show" max-width="1250px" scrollable>
    <v-card>
      <v-card-title class="py-2 rdg-naslov">
        <span class="rdg-ime">{{ naslov }}</span>
        <span class="rdg-meta ml-4">{{ podnaslov }}</span>
        <v-spacer></v-spacer>
        <v-checkbox
          v-model="sKontima"
          dense
          hide-details
          class="mt-0 pt-0 mr-4 kvacica"
          label="Konta u ispisu"
        ></v-checkbox>
        <v-btn small outlined color="primary" class="mr-2" @click="ispisi">Printaj</v-btn>
        <v-btn small outlined class="mr-2" @click="uExcel">Excel</v-btn>
        <v-btn icon @click="show = false"><v-icon>mdi-close</v-icon></v-btn>
      </v-card-title>
      <v-divider></v-divider>

      <v-card-text class="pa-0" style="max-height: 74vh;">
        <table class="rdg-tbl">
          <colgroup>
            <col style="width:56px">
            <col style="width:210px">
            <col>
            <col style="width:150px">
            <col style="width:150px">
          </colgroup>
          <thead>
            <tr>
              <th class="l">Ozn.</th>
              <th class="l">Konta iz RRiF-ovog plana</th>
              <th class="l">Naziv pozicije</th>
              <th>{{ prethodnaGodina }}</th>
              <th>{{ tekucaGodina }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(r, i) in redci" :key="i" :class="klasaRetka(r)">
              <td class="ozn">{{ r.col1 }}</td>
              <td class="konta">{{ r.col2 }}</td>
              <td class="naziv">{{ ocisti(r.col3) }}</td>
              <td class="num" :class="{nula: !r.col5}">{{ iznos(r.col5) }}</td>
              <td class="num" :class="{nula: !r.col6}">{{ iznos(r.col6) }}</td>
            </tr>
          </tbody>
        </table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
// Prikaz financijskog izvjestaja na ekranu - racuna dobitka i gubitka i
// GFI-POD bilance. Oba izvjestaja daju retke istog oblika, pa dijele prikaz.
//
// Otvara se preko ref-a, iz MainLedgerCard1 nakon sto rdg2() ili doAll() slozi retke:
//   <MainLedgerStatement ref="izvjestaj" />
//   this.$refs.izvjestaj.open(this.fRDG, this.currency, 'Račun dobitka i gubitka')
//
// Tri su razine i razlikuju se po zastavicama:
//   header true             - rimski broj, zbroj cijelog odjeljka
//   header false, bold true - numerirana pozicija
//   oboje false             - podredak a) b) c), u col3 ima uvodni tab

import dayjs from 'dayjs'
import {printStatementPdf} from './mainLedgerPdf'
import {exportStatementXlsx} from './mainLedgerXlsx'

export default {
  name: 'MainLedgerStatement',
  data () {
    return {
      show: false,
      redci: [],
      head: {},
      currency: 'EUR',
      naslov: 'Račun dobitka i gubitka',
      // Kolona s kontima ostaje na ekranu radi provjere, ali u ispis i izvoz
      // ne ide osim ako se to izricito ne ukljuci - iz nje se vidi kako je RDG
      // sastavljen, a to korisnik servisa ne treba dobiti u ruke.
      sKontima: false
    }
  },
  computed: {
    tekucaGodina () {
      return this.head.docToDate ? dayjs(this.head.docToDate).year() : 'Tekuća godina'
    },
    prethodnaGodina () {
      return this.head.docToDate ? dayjs(this.head.docToDate).year() - 1 : 'Prethodna godina'
    },
    podnaslov () {
      if (!this.head.docFromDate) { return this.currency }
      return dayjs(this.head.docFromDate).format('DD.MM.YYYY') + ' – ' +
        dayjs(this.head.docToDate).format('DD.MM.YYYY') + ' · ' + this.currency
    }
  },
  methods: {
    iznos (v) {
      if (!v || Math.abs(v) < 0.005) { return '–' }
      return Number(v).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    // col3 podredaka pocinje tabom; uvlaka se radi stilom, ne znakovima.
    ocisti (t) {
      return t ? String(t).replace(/^[\t\s]+/, '') : ''
    },
    klasaRetka (r) {
      if (r.header) { return 'odjeljak' }
      if (r.bold) { return 'pozicija' }
      return 'podredak'
    },
    open (fRDG, currency, naslov) {
      this.redci = fRDG && fRDG.items ? fRDG.items : []
      this.head = fRDG && fRDG.head ? fRDG.head : {}
      this.currency = currency || 'EUR'
      this.naslov = naslov || 'Račun dobitka i gubitka'
      this.show = true
    },
    zaIzvoz () {
      return {
        redci: this.redci,
        company: this.$store.state.companyActiv ? this.$store.state.companyActiv : {},
        fromDate: this.head.docFromDate,
        toDate: this.head.docToDate,
        valuta: this.currency,
        tekucaGodina: this.tekucaGodina,
        prethodnaGodina: this.prethodnaGodina,
        sKontima: this.sKontima,
        naslov: this.naslov
      }
    },
    ispisi () {
      printStatementPdf(this.zaIzvoz())
    },
    uExcel () {
      exportStatementXlsx(this.zaIzvoz())
    }
  }
}
</script>

<style scoped>
.rdg-naslov { font-size: 16px; }
.kvacica >>> label { font-size: 13px; }
.rdg-ime { font-weight: 700; }
.rdg-meta { font-size: 14px; color: rgba(0, 0, 0, .55); }

.rdg-tbl {
  border-collapse: collapse;
  width: 100%;
  font-size: 15px;
  color: #191d1c;
}

.rdg-tbl thead th {
  position: sticky;
  top: 0;
  background: #fff;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: .07em;
  text-transform: uppercase;
  color: #79827e;
  text-align: right;
  vertical-align: bottom;
  padding: 8px 10px;
  white-space: nowrap;
  border-bottom: 1px solid #c7cfcb;
  z-index: 2;
}
.rdg-tbl thead th.l { text-align: left; }

.rdg-tbl tbody td {
  padding: 3px 10px;
  border-bottom: 1px solid #e2e6e3;
  vertical-align: baseline;
}
.rdg-tbl td.num {
  text-align: right;
  font-variant-numeric: tabular-nums;
  font-size: 14px;
  white-space: nowrap;
}
.rdg-tbl td.nula { color: #b6bdb9; }
.rdg-tbl td.ozn { font-weight: 600; white-space: nowrap; }
.rdg-tbl td.konta { font-size: 13px; color: #79827e; }

/* tri razine, razlikuju se uvlakom i debljinom - bez podloga */
.rdg-tbl tr.odjeljak td {
  font-weight: 700;
  border-top: 2px solid #14534c;
  padding-top: 7px;
  padding-bottom: 5px;
}
.rdg-tbl tr.odjeljak td.ozn { color: #14534c; }
.rdg-tbl tr.odjeljak td.naziv { text-transform: uppercase; letter-spacing: .03em; font-size: 14px; }

.rdg-tbl tr.pozicija td { font-weight: 600; border-top: 1px solid #c7cfcb; }
.rdg-tbl tr.pozicija td.naziv { padding-left: 24px; }

.rdg-tbl tr.podredak td { color: #4a524f; }
.rdg-tbl tr.podredak td.naziv { padding-left: 46px; }
.rdg-tbl tr.podredak:hover td { background: #f1f5f3; }
</style>
